<script>
  import * as firebase from "firebase/app";
  import "firebase/database";

  const totalFromSnap = snap =>
    new Intl.NumberFormat().format(
      Object.values(snap.val() || {}).reduce(
        (acc, distance) => acc + distance,
        0
      )
    );

  let total;

  firebase
    .database()
    .ref("distance")
    .on("value", snap => (total = totalFromSnap(snap)));
</script>

<style>
  h1 {
    font-size: 3.5rem;
    word-break: break-word;
    margin: 0;
    font-weight: 900;
  }

  h2 {
    font-size: 1.25rem;
    margin: 0;
    word-wrap: break-word;
    text-transform: uppercase;
  }

  p {
    margin: 0;
    font-size: 1.5rem;
  }

  @media screen and (min-width: 640px) {
    h1 {
      font-size: 4rem;
    }

    h2 {
      font-size: 2.6rem;
    }
  }
</style>

{#if total}
  <h2>Tillsammans har vi gått</h2>
  <h1>{total} M</h1>
{/if}
